module.exports = __webpack_public_path__ + "img/Instagram.325ee4a3.png";